var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundOff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49756 3.60254L2.44678 1.55762H2.51709C2.53174 1.55762 2.54932 1.54883 2.56104 1.53711L3.69775 0.479492C3.85889 0.330078 3.96436 0.265625 4.11377 0.265625C4.33643 0.265625 4.49756 0.441406 4.49756 0.658203V3.60254ZM5.52002 5.79102L0.393066 0.672852C0.305176 0.582031 0.305176 0.429688 0.393066 0.341797C0.483887 0.250977 0.633301 0.250977 0.724121 0.341797L5.84814 5.46289C5.93896 5.55371 5.93896 5.7002 5.84814 5.79102C5.76025 5.88184 5.61084 5.88184 5.52002 5.79102ZM1.56201 4.12695C1.13428 4.12695 0.914551 3.90137 0.914551 3.44727V2.33398C0.914551 2.12012 0.964355 1.95605 1.06396 1.84766L4.46826 5.25195C4.4126 5.4248 4.28369 5.50684 4.1167 5.50684C3.96729 5.50684 3.84717 5.44824 3.69775 5.30762L2.45557 4.15039C2.43799 4.13281 2.41748 4.12695 2.38818 4.12695H1.56201Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOff);
export default __webpack_public_path__ + "static/media/sound-off.dc00ddfdca34a2b2c700086b7c551200.svg";
export { ForwardRef as ReactComponent };